import React from "react";
import { RadialBarChart, RadialBar, Tooltip, Legend } from "recharts";

const RadialChart = ({ data }) => {
  // Calculate total value for percentage calculations
  const totalValue = data.reduce((total, item) => total + item.value, 0);

  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        margin: "auto",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <RadialBarChart
        width={400}
        height={400}
        cx={200}
        cy={200}
        innerRadius={50}
        outerRadius={170}
        barSize={30}
        data={data}
        startAngle={90}
        endAngle={-180}
      >
        <defs>
          <linearGradient id="color1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#9B59B6" />
            <stop offset="100%" stopColor="#442750" />
          </linearGradient>
          <linearGradient id="color2" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#757BC8" />
            <stop offset="100%" stopColor="#A0A3CC" />
          </linearGradient>
          <linearGradient id="color3" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ADA7FF" />
            <stop offset="100%" stopColor="#CBC7FF" />
          </linearGradient>
          <linearGradient id="color4" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E0C3FC" />
            <stop offset="100%" stopColor="#E7DFF7" />
          </linearGradient>
        </defs>
        <RadialBar
          minAngle={15}
          background={false}
          clockWise={true}
          dataKey="value"
          label={{
            position: "insideStart",
            fill: "#fff",
            formatter: (value, entry) =>
              `${((value / totalValue) * 100).toFixed(1)}%`,
          }}
          cornerRadius={10}
          fill="#fff"
          stroke="none"
          style={{ cursor: "pointer" }}
        />
        <Tooltip
          cursor={false}
          content={({ payload }) => {
            if (!payload || payload.length === 0) return null;
            const data = payload[0];
            const percentage = ((data.value / totalValue) * 100).toFixed(1);
            return (
              <div
                style={{
                  background: "white",
                  padding: 5,
                  border: "1px solid #ccc",
                }}
              >
                <div>{data.payload.name}</div>
                <div>
                  Value:{" "}
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(data.value)}
                </div>
                <div>Percentage: {percentage}%</div>
              </div>
            );
          }}
        />

        <Legend
          iconSize={10}
          layout="horizontal"
          verticalAlign="bottom"
          align="center"
          //   formatter={(value, entry) => {
          //     const percentage = (
          //       (entry.payload.value / totalValue) *
          //       100
          //     ).toFixed(1);
          //     return `${value} (${percentage}%)`;
          //   }}
        />
      </RadialBarChart>
    </div>
  );
};

export default RadialChart;
